import { SEOHead } from '@/components/@next/SEOHead';
import { Privacy as PrivacyPage } from '@/containers/privacyPolicy/privacyPolicy';
import NextApp from '../NextApp';

export default function Privacy() {
  return (
    <NextApp>
      <SEOHead title="Privacy" />
      <PrivacyPage />
    </NextApp>
  );
}
